export type EmailIsExistResult = {
  listUsers?: {
    __typename: "ModelUserConnection";
    items?: Array<{
      __typename: "User";
      id: string;
    } | null> | null;
  } | null;
};

export const emailIsExist = /* GraphQL */ `
  query IsEmailExist($email: String) {
    listUsers(limit: 10000, filter: { email: { eq: $email } }) {
      items {
        id
      }
    }
  }
`;

export type ListSelectableGroupResult = {
  listUsers?: {
    __typename: "ModelUserConnection";
    items?: Array<{
      __typename: "User";
      id: string;
      group_id: string;
    } | null> | null;
  } | null;
};

export const listSelectableGroup = /* GraphQL */ `
  query listSelectableGroup($email: String) {
    listUsers(limit: 10000, filter: { email: { eq: $email } }) {
      items {
        id
        group_id
      }
    }
  }
`;
